<template>
  <q-separator />
</template>
